/* tslint:disable */
/* eslint-disable */
/**
 * Presentation API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SectionFetchRequestDto
 */
export interface SectionFetchRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SectionFetchRequestDto
     */
    id: string;
    /**
     * 
     * @type {object}
     * @memberof SectionFetchRequestDto
     */
    config?: object;
}

/**
 * Check if a given object implements the SectionFetchRequestDto interface.
 */
export function instanceOfSectionFetchRequestDto(value: object): value is SectionFetchRequestDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function SectionFetchRequestDtoFromJSON(json: any): SectionFetchRequestDto {
    return SectionFetchRequestDtoFromJSONTyped(json, false);
}

export function SectionFetchRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionFetchRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'config': json['config'] == null ? undefined : json['config'],
    };
}

export function SectionFetchRequestDtoToJSON(json: any): SectionFetchRequestDto {
    return SectionFetchRequestDtoToJSONTyped(json, false);
}

export function SectionFetchRequestDtoToJSONTyped(value?: SectionFetchRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'config': value['config'],
    };
}

